// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__6hSBe","title":"card_title__32vbZ","inActive":"card_inActive__2wtPn"};